module.exports = __webpack_public_path__ + "img/twitter_may21.c58790a1.png";